import { render, staticRenderFns } from "./D2CApplicationSuccessPage.vue?vue&type=template&id=e68565bc&scoped=true&"
import script from "./D2CApplicationSuccessPage.vue?vue&type=script&lang=js&"
export * from "./D2CApplicationSuccessPage.vue?vue&type=script&lang=js&"
import style0 from "./D2CApplicationSuccessPage.vue?vue&type=style&index=0&id=e68565bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68565bc",
  null
  
)

export default component.exports